export default {
  placeholder: 'All',
  selectAllLabel: 'All',
  all: 'All',
  filtered: 'filtered',
  filteredPlural: 'filtered',
  negated: 'negated',
  negatedPlural: 'negated',
};
